import React from "react";
import styles from "components/administration/appNavigationManager/iconSelection.module.css";
import { map } from "lodash";
import classnames from "classnames";
import Label from "components/shared/form/Label";
import { useController, useFormContext } from "react-hook-form";
import {
  faBook,
  faBookmark,
  faBullhorn,
  faCalendar,
  faCertificate,
  faCog,
  faColumns,
  faComments,
  faEnvelope,
  faExternalLink,
  faFileText,
  faFlag,
  faFolder,
  faFolderOpen,
  faGlobe,
  faHandshake,
  faLink,
  faListAlt,
  faPaperclip,
  faUserCircle,
  faUsers,
  faBell,
  faCarSide,
  faChartSimple,
  faCheck,
  faCompass,
  faFaceSmile,
  faFlask,
  faGift,
  faHand,
  faHeadphones,
  faHouse,
  faLock,
  faPenNib,
  faPhone,
  faPuzzlePiece,
  faRocketLaunch,
  faShieldHalved,
  faShop,
  faSignPost,
  faSitemap,
  faStar,
  faTag,
  faText,
  faThumbsUp,
  faTrain,
  faTriangleExclamation,
  faVolume,
  faWebAwesome,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";
import { faFile } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ICONS = {
  faGlobe,
  faEnvelope,
  faComments,
  faCalendar,
  faFolderOpen,
  faListAlt,
  faFile,
  faCog,
  faLink,
  faExternalLink,
  faUserCircle,
  faUsers,
  faFolder,
  faFileText,
  faColumns,
  faPaperclip,
  faBook,
  faBullhorn,
  faCertificate,
  faBookmark,
  faFlag,
  faHandshake,
  faBell,
  faCarSide,
  faChartSimple,
  faCheck,
  faCompass,
  faFaceSmile,
  faFlask,
  faGift,
  faHand,
  faHeadphones,
  faHouse,
  faLock,
  faPenNib,
  faPhone,
  faPuzzlePiece,
  faRocketLaunch,
  faShieldHalved,
  faShop,
  faSignPost,
  faSitemap,
  faStar,
  faTag,
  faText,
  faThumbsUp,
  faTrain,
  faTriangleExclamation,
  faVolume,
  faWebAwesome,
  faXmark,
};

type IconPickerArgs = {
  name: string;
  label: string;
  disabled?: boolean;
};
export default function IconPicker({ name, label, disabled }: IconPickerArgs) {
  const { control } = useFormContext();
  const { field } = useController({ control, name });

  function selectIcon(
    e: React.MouseEvent<HTMLButtonElement>,
    iconName: string,
  ) {
    e.preventDefault();

    if (field.value == iconName) {
      field.onChange(null);
    } else {
      field.onChange(iconName);
    }
  }

  return (
    <div className="control-group">
      <Label label={label} />
      <div className="controls border-box p-1 flex flex-wrap">
        {map(ICONS, (icon, iconName) => (
          <button
            className={classnames(
              "rounded hover:bg-primary/10 hover:text-primary",
              styles.iconButton,
              {
                "bg-primary/10 text-primary border-primary":
                  iconName == field.value,
              },
            )}
            disabled={disabled}
            onClick={(e) => selectIcon(e, iconName)}
            key={iconName}
          >
            <FontAwesomeIcon icon={icon} />
          </button>
        ))}
      </div>
    </div>
  );
}
